// www/src/hooks/useTheme.js
import { useEffect, useState } from 'react';
import { THEMES, DEFAULT_THEME, findTheme } from '../themes/themes';
import { useSiteSettings } from '../context/SiteSettingsContext';

const FONT_LINK_ID = 'peony-theme-font';
const SESSION_KEY = 'peony.previewTheme';

function applyBodyTheme(theme) {
  document.body.dataset.theme = theme.slug;
}

function loadFontsFor(theme) {
  let link = document.getElementById(FONT_LINK_ID);
  if (!link) {
    link = document.createElement('link');
    link.id = FONT_LINK_ID;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }
  if (link.href !== theme.fontsHref) link.href = theme.fontsHref;
}

function readQueryThemeOverride() {
  const url = new URL(window.location.href);
  const q = url.searchParams.get('theme');
  if (!q) return null;
  const theme = findTheme(q);
  if (!theme) return null;
  try { window.sessionStorage.setItem(SESSION_KEY, theme.key); } catch (_) {}
  return theme;
}

function readStoredOverride() {
  try {
    const key = window.sessionStorage.getItem(SESSION_KEY);
    return findTheme(key);
  } catch (_) { return null; }
}

export function useTheme() {
  const { settings } = useSiteSettings();
  const [themeKey, setThemeKey] = useState(DEFAULT_THEME);

  useEffect(() => {
    const override = readQueryThemeOverride() || readStoredOverride();
    if (override) {
      setThemeKey(override.key);
      applyBodyTheme(override);
      loadFontsFor(override);
      return;
    }
    const theme = findTheme(settings?.activeTheme) || findTheme(DEFAULT_THEME);
    setThemeKey(theme.key);
    applyBodyTheme(theme);
    loadFontsFor(theme);
  }, [settings?.activeTheme]);

  return { themeKey, themes: THEMES };
}
